module.exports = "<p>\n  project-design-issue-all-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/project-design-issue-total/project-design-issue-all-form/project-design-issue-all-form.component.html
// module id = ./src/app/technical/project-design-issue-total/project-design-issue-all-form/project-design-issue-all-form.component.html
// module chunks = main